import React, { useMemo, useState } from "react";
import AppShell from "../components/ui/AppShell";
import PageHeader from "../components/ui/PageHeader";

const defaultRows = [
  { key: "full_name", value: "" },
  { key: "email", value: "" },
  { key: "phone", value: "" },
];

const QuickFormPage = () => {
  const [title, setTitle] = useState("Temporary Form");
  const [notes, setNotes] = useState("");
  const [rows, setRows] = useState(defaultRows);
  const [message, setMessage] = useState("");

  const payload = useMemo(() => {
    const data = {};
    rows.forEach((row) => {
      const cleanKey = (row.key || "").trim();
      if (cleanKey) {
        data[cleanKey] = row.value;
      }
    });

    return {
      title,
      notes,
      fields: data,
      savedAt: new Date().toISOString(),
    };
  }, [title, notes, rows]);

  const handleRowChange = (index, prop, value) => {
    setRows((prev) =>
      prev.map((row, i) => (i === index ? { ...row, [prop]: value } : row))
    );
  };

  const addField = () => {
    setRows((prev) => [...prev, { key: "", value: "" }]);
  };

  const removeField = (index) => {
    setRows((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSaveDraft = () => {
    localStorage.setItem("quick_form_draft", JSON.stringify(payload));
    setMessage("Draft saved locally. Field structure can be updated later.");
  };

  return (
    <AppShell>
      <PageHeader
        title="Quick Form"
        description="Temporary form page is ready. You can tell me exact fields later and I will convert this into the final form."
      />

      <div className="card">
        <div className="card-body p-4">
          <div className="mb-3">
            <label className="form-label fw-semibold">Form Title</label>
            <input
              className="form-control"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Enter form title"
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold">Notes</label>
            <textarea
              className="form-control"
              rows="3"
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="Any instructions for this form"
            />
          </div>

          <h6 className="mb-2">Fields</h6>
          {rows.map((row, index) => (
            <div className="row g-2 mb-2" key={`${index}-${row.key}`}>
              <div className="col-md-4">
                <input
                  className="form-control"
                  value={row.key}
                  onChange={(e) => handleRowChange(index, "key", e.target.value)}
                  placeholder="field_name"
                />
              </div>
              <div className="col-md-6">
                <input
                  className="form-control"
                  value={row.value}
                  onChange={(e) => handleRowChange(index, "value", e.target.value)}
                  placeholder="field value"
                />
              </div>
              <div className="col-md-2 d-grid">
                <button
                  type="button"
                  className="btn btn-outline-danger"
                  onClick={() => removeField(index)}
                >
                  Remove
                </button>
              </div>
            </div>
          ))}

          <div className="d-flex gap-2 mt-3">
            <button type="button" className="btn btn-outline-primary" onClick={addField}>
              Add Field
            </button>
            <button type="button" className="btn btn-primary" onClick={handleSaveDraft}>
              Save Draft
            </button>
          </div>

          {message && <div className="alert alert-success mt-3 mb-0">{message}</div>}
        </div>
      </div>
    </AppShell>
  );
};

export default QuickFormPage;
